import { PerformanceProcessAgreementSignedByFragment } from 'generated/resources/graphql'
import { compact } from 'lodash'

import i18n from 'modules/core/lib/i18n'

const nameOrYou = (
  access: { id: number; fullName: string } | undefined | null,
  currentAccessId: number
) => {
  if (!access) return undefined

  return access.id === currentAccessId
    ? i18n.t('performance_process.agreements.agreement.you_as_signer')
    : access.fullName
}

// This function is used to translate the signed by text in an agreement. It
// will conditionally show different text depending on who has signed the
// agreement.
//
// Examples: "Signed by you and John Doe on behalf of Marie Antoinette"
export const signedBy = (
  agreement: PerformanceProcessAgreementSignedByFragment,
  currentAccessId: number
) => {
  if (!agreement.targetSignedAt && !agreement.managerSignedAt) return undefined

  const reviewerAccess = agreement?.managerEvaluation?.reviewerAccess

  const signerName =
    agreement.signer && agreement.signer?.id !== reviewerAccess?.id
      ? i18n.t('performance_process.agreements.agreement.signed_by_on_behalf', {
          name1: nameOrYou(agreement?.signer, currentAccessId),
          name2: nameOrYou(reviewerAccess, currentAccessId),
        })
      : reviewerAccess && nameOrYou(reviewerAccess, currentAccessId)

  if (agreement.targetSignedAt && agreement.managerSignedAt) {
    if (agreement.signer?.id !== reviewerAccess?.id) {
      return i18n.t('performance_process.agreements.agreement.signed_by_plural', {
        name1: agreement.target.access && nameOrYou(agreement.target.access, currentAccessId),
        name2: signerName,
      })
    }
  }

  const names = compact([
    agreement?.managerSignedAt ? signerName : null,
    agreement?.targetSignedAt && agreement.target?.access
      ? nameOrYou(agreement.target?.access, currentAccessId)
      : null,
  ])

  return i18n.t('performance_process.agreements.agreement.signed_by_singular', { name: names[0] })
}
